<template>
    <div class="login">
        <div class="dialog-form" id="my_form">
            <input type="text" placeholder="用户名" v-model="userName">
            <input type="password" placeholder="密码" v-model="password">
            <div class="btn-login">
                <el-button type="primary" @click.prevent="loginEvent">登 录</el-button>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import { get, post } from '@/api/index'
import { mapState, mapActions } from 'vuex'
import jquery from '@/assets/js/jquery-3.3.1.min.js'
import jqueryForm from '@/assets/js/jquery.form.min.js'

export default {
    data() {
        return {
            userName: '',
            password: '',
            validateDate: {}
        }
    },
    inject: ['reload'],
    mounted() {
        // this.initGeet();
    },
    computed: {
        ...mapState([
            'signatrue',
            'userLevel'
        ])
    },
    methods: {
        // 登录
        loginEvent() {
            var param = {};
            param['userName'] = this.userName;
            param['userPassword'] = this.password;
            post(this.$url_LN_local+'/validation/user', param).then((resp) => {
                if (resp.code === 200) {
                    this.$store.commit('setUnilateralSig', resp.token);
                    this.$store.commit('setUnilateralLevel', resp.pes);
                    this.$cookies.set('tokenSig', resp.token, '2D');
                    this.$cookies.set('level', resp.pes, '2D');
                    this.$cookies.set("userName", this.userName, '2D');
                    sessionStorage.setItem('userName', this.userName);

                    // this.$store.commit('getUserName', this.userName);
                    // this.$store.commit('setUnilateralSig', resp.token);
                    // this.$store.commit('setUnilateralLevel', resp.pes);

                    if (this.$route.path == '/login' || this.$route.path == '/') {
                        this.$router.push('/unilateral')
                    } else {
                        this.reload();
                    }
                } else {
                    this.$notify.error({
                        title: '错误',
                        message: resp.info,
                        offset: 100
                    })

                    // 刷新页面
                    this.reload();
                }
            }).catch(error => {
                this.$notify.error({
                    title: '错误',
                    message: error,
                    offset: 100
                })
            })
        },
    }
}
</script>

<style lang="scss">
.login{
    padding: 20px 0;
    .dialog-form{
        width: 80%;
        margin: 0 auto;
        .geet-content{
            display: inline-block;
            width: 96%;
            #embed-captcha{
                width: 100% !important;
                border: 0;
                .geetest_holder{
                    width: 100% !important;
                    min-width: 0;
                    border: 0;
                }
            }
        }
        input{
            border-radius: 5px;
            border: 0px solid #000;
            height: 40px;
            outline: none;
            width: 94%;
            margin-bottom: 10px;
            padding: 0 1%;
            padding-left: 5px;
            background-color: #000 !important;
            color: #807c7c;
        }
    
        // 利用动画延迟
        input:-webkit-autofill,
        input:-webkit-autofill:hover,
        input:-webkit-autofill:focus, 
        input:-webkit-autofill:active {
            transition-delay: 99999s;
            transition: color 99999s ease-out, background-color 99999s ease-out;
            -webkit-transition-delay: 99999s;
            -webkit-transition: color 99999s ease-out, background-color 99999s ease-out;
            -webkit-text-fill-color: #807c7c;
        }

        .el-input{
            padding: 5px;
            .el-input__inner{
                background-color: #1e1e1e !important;
                border-color: #1e1e1e !important;
            }
            .el-input__inner:focus{
                color: #fff;
            }
        }
        .btn-login{
            padding: 5px;
            display: inline-block;
            width: 96%;
            .el-button{
                width: 100%;
                background-color: #eb602e;
                border-color: #eb602e;
            }
            .el-button:hover{
                background-color: #8c3c1f;
            }
        }
        .notice{
            color: #807c7c;
            font-size: 13px;
            text-align: right;
            padding: 5px 0;
            a:hover{
                cursor: pointer;
                color: #fff;
            }
        }
    }
    .show{
        display: block;
    }
    .hide{
        display: none;
    }
}
</style>
